import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** リース契約満了後の処理 */
enum AfterContractExpirationProcessing {
  reLease = '1',
  expired = '2',
}

const nameConfig = {
  reLease: new Map([[Locale.ja, '契約を再リースする']]),
  expired: new Map([[Locale.ja, '契約を満了する']]),
};

const toEnum = rawValueToEnum(AfterContractExpirationProcessing, AfterContractExpirationProcessing.reLease);
const toDisplay = enumToName(AfterContractExpirationProcessing, nameConfig);
const toDisplayWithPrefix = enumToName(AfterContractExpirationProcessing, nameConfig, { prefix: true });

export const afterContractExpirationProcessing = {
  enum: AfterContractExpirationProcessing,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { AfterContractExpirationProcessing };
